import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Msg } from './';
import './messages.scss';

class Messages extends Component {
    render() {
        const list = this.props.messages.list || []
        const msgs = list.map((item, index) => (
            <Msg key={index} {...item}/>
        ));

        return (
            <div id="messages">
                {msgs}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        messages: state.messagesReducer
    }
}

const MessagesWithRedux = connect(mapStateToProps)(Messages);

export {MessagesWithRedux as Messages};


// WEBPACK FOOTER //
// ./src/components/Messages/Messages.jsx